import { useTranslation } from 'react-i18next';

import {
  FiltersWrapper,
  InputContainer,
  SearchInputContainer,
} from '../../../SimplePage/Filters';
import Checkbox from '../../../UI/Checkbox/Checkbox';
import IconInput from '../../../UI/IconInput/IconInput';
import { MainSelect } from '../../../UI/MainSelect/MainSelect';
import {
  membersTypesOptions,
  renewStatusOptions,
} from './keMembersFilters.const';
import { useKEMembersFilters } from './keMembersFilters.hooks';
import {
  KEMembersFiltersProps,
  KEMembersListFilters,
} from './keMembersFilters.models';

const KEMembersFilters = ({
  availableFilters,
  standardPricing,
}: KEMembersFiltersProps) => {
  const { t } = useTranslation();
  const {
    filters,
    onFilterChangeHandler,
    plansOptions,
    subscriptionsListOptions,
  } = useKEMembersFilters({ standardPricing });

  const filtersComponents = availableFilters.map((filter) => {
    switch (filter) {
      case KEMembersListFilters.Search:
        return (
          <SearchInputContainer key={KEMembersListFilters.Search}>
            <IconInput
              defaultIcon="search"
              onChange={(evt) =>
                onFilterChangeHandler(evt, KEMembersListFilters.Search)
              }
              placeholder={t('filters.search-by')}
              value={filters.search}
            />
          </SearchInputContainer>
        );
      case KEMembersListFilters.Plan:
        return (
          <InputContainer key={KEMembersListFilters.Plan}>
            <MainSelect
              currentValue={filters.plan}
              isClearable
              isMulti
              onChange={(evt: any) =>
                onFilterChangeHandler(evt, KEMembersListFilters.Plan)
              }
              options={plansOptions}
              placeholder={t('filters.plan')}
            />
          </InputContainer>
        );
      case KEMembersListFilters.MemberType:
        return (
          <InputContainer key={KEMembersListFilters.MemberType}>
            <MainSelect
              currentValue={filters.memberType}
              isClearable
              isMulti
              onChange={(evt: any) =>
                onFilterChangeHandler(evt, KEMembersListFilters.MemberType)
              }
              options={membersTypesOptions}
              placeholder={t('filters.member')}
            />
          </InputContainer>
        );
      case KEMembersListFilters.RenewStatus:
        return (
          <InputContainer key={KEMembersListFilters.RenewStatus}>
            <MainSelect
              currentValue={filters.renewStatus}
              isClearable
              onChange={(evt: any) =>
                onFilterChangeHandler(evt, KEMembersListFilters.RenewStatus)
              }
              options={renewStatusOptions}
              placeholder={t('filters.renew-status')}
            />
          </InputContainer>
        );
      case KEMembersListFilters.SubscriptionId:
        return (
          <InputContainer key={KEMembersListFilters.SubscriptionId}>
            <MainSelect
              currentValue={filters.subscriptionId}
              isClearable
              isMulti
              onChange={(evt: any) =>
                onFilterChangeHandler(evt, KEMembersListFilters.SubscriptionId)
              }
              options={subscriptionsListOptions}
              placeholder={t('filters.subscription')}
            />
          </InputContainer>
        );
      case KEMembersListFilters.OversubscribedOnly:
        return (
          <Checkbox
            key={KEMembersListFilters.OversubscribedOnly}
            checked={!!filters.oversubscribedOnly}
            onChange={(evt: any) =>
              onFilterChangeHandler(
                evt,
                KEMembersListFilters.OversubscribedOnly,
              )
            }
            label={t('filters.only-subscribed')}
          />
        );
      default:
        return null;
    }
  });

  return <FiltersWrapper>{filtersComponents}</FiltersWrapper>;
};

export default KEMembersFilters;
